import { createRoute } from '@tanstack/react-router';
import { lawyerRoute } from './index';
import { PricingWizard } from '@/components/pricing/PricingWizard';

function PricingPage() {
  return (
    <div className="p-6">
      <PricingWizard />
    </div>
  );
}

export const lawyerPricingRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/pricing',
  component: PricingPage,
});
